export function getWithdrawalUrl(baseUrl, orderData) {
  const url = new URL(baseUrl);

  const params = {
    firstname: orderData.firstName,
    lastname: orderData.lastName,
    orderdate: orderData.orderDate,
    emailaddress: orderData.email,
    orderid: orderData.orderId,
    vehiclemodel: orderData.versionLabel,
  };

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}
